if (!window.radiantCurtainMeasurementGuardInstalled) {
  window.radiantCurtainMeasurementGuardInstalled = true;

  const guardCurtainMeasurements = (event) => {
    let productForm = null;
    if (event.type === 'submit' && event.target instanceof HTMLFormElement) {
      productForm = event.target;
    } else if (event.type === 'click') {
      const addButton = event.target.closest('button[name="add"], input[name="add"]');
      productForm = addButton && addButton.form;
    }
    if (!productForm) return;

    const widthInput = productForm.elements.namedItem('properties[Track or pole width]');
    const dropInput = productForm.elements.namedItem('properties[Finished drop]');
    if (!widthInput || !dropInput) return;

    const validMeasurement = (input) => {
      const value = parseFloat(input.value);
      return Number.isFinite(value) && input.validity.valid;
    };
    const customizer = widthInput.closest('curtain-customizer');
    const firstInvalid = [widthInput, dropInput].find((input) => !validMeasurement(input));
    if (!firstInvalid) {
      if (customizer && typeof customizer.syncApiPPACalculator === 'function') customizer.syncApiPPACalculator();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    [widthInput, dropInput].forEach((input) => {
      if (!validMeasurement(input)) input.setAttribute('aria-invalid', 'true');
    });

    const measurementStep = customizer && customizer.querySelector('[data-curtain-measurements]');
    const measurementError = customizer && customizer.querySelector('[data-curtain-measurement-error]');
    if (measurementStep) {
      measurementStep.classList.add('is-invalid');
      measurementStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (measurementError) measurementError.hidden = false;
    window.setTimeout(() => firstInvalid.focus({ preventScroll: true }), 450);
  };

  document.addEventListener('click', guardCurtainMeasurements, true);
  document.addEventListener('submit', guardCurtainMeasurements, true);
}

if (!window.radiantCurtainGalleryInstalled) {
  window.radiantCurtainGalleryInstalled = true;

  const showCurtainGalleryImage = (modal, requestedIndex, behavior = 'smooth') => {
    const scroller = modal && modal.querySelector('[data-radiant-gallery-scroller]');
    if (!scroller) return;

    const slides = scroller.querySelectorAll('.radiant-curtain-media-modal__slide');
    if (!slides.length) return;

    const index = ((requestedIndex % slides.length) + slides.length) % slides.length;
    scroller.scrollTo({ left: index * scroller.clientWidth, behavior });
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('modal-opener[data-radiant-gallery-index]');
    if (opener) {
      const modal = document.querySelector(opener.dataset.modal);
      const index = Number.parseInt(opener.dataset.radiantGalleryIndex, 10) || 0;
      window.requestAnimationFrame(() => showCurtainGalleryImage(modal, index, 'auto'));
      return;
    }

    const navigation = event.target.closest('[data-radiant-gallery-direction]');
    if (!navigation) return;

    const modal = navigation.closest('.radiant-curtain-media-modal');
    const scroller = modal && modal.querySelector('[data-radiant-gallery-scroller]');
    if (!scroller || !scroller.clientWidth) return;

    const currentIndex = Math.round(scroller.scrollLeft / scroller.clientWidth);
    const direction = Number.parseInt(navigation.dataset.radiantGalleryDirection, 10) || 0;
    showCurtainGalleryImage(modal, currentIndex + direction);
  });
}

if (!customElements.get('curtain-customizer')) {
  customElements.define(
    'curtain-customizer',
    class CurtainCustomizer extends HTMLElement {
      connectedCallback() {
        this.widthInput = this.querySelector('[data-curtain-width]');
        this.dropInput = this.querySelector('[data-curtain-drop]');
        this.fullnessInput = this.querySelector('[data-curtain-fullness]');
        this.summary = this.querySelector('[data-curtain-summary]');
        this.helper = this.querySelector('[data-curtain-helper]');
        this.summaryInput = this.querySelector('[data-curtain-summary-input]');
        this.whatsappSummaryInput = this.querySelector('[data-curtain-whatsapp-summary]');
        this.whatsappLink = this.querySelector('[data-curtain-whatsapp-link]');
        this.emailInput = this.querySelector('[data-curtain-email]');
        this.phoneInput = this.querySelector('[data-curtain-phone]');
        this.measurementStep = this.querySelector('[data-curtain-measurements]');
        this.measurementError = this.querySelector('[data-curtain-measurement-error]');
        this.pricePanel = this.querySelector('[data-curtain-price-panel]');
        this.calculatedPriceOutput = this.querySelector('[data-curtain-calculated-price]');
        this.calculatedPriceInput = this.querySelector('[data-curtain-price-input]');
        const productFormId = this.widthInput && this.widthInput.getAttribute('form');
        this.productForm = productFormId ? document.getElementById(productFormId) : null;
        this.quantityInput = null;
        this.livePanels = document.querySelectorAll('[data-curtain-live]');
        this.liveLabelGroups = document.querySelectorAll('[data-curtain-live-labels]');
        this.liveDescriptions = document.querySelectorAll('[data-curtain-live-description]');
        this.productDescriptions = document.querySelectorAll('.product__description');
        this.unit = this.dataset.unit || 'in';
        this.currencyCode = this.dataset.currencyCode || 'USD';
        this.whatsappNumber = this.dataset.whatsappNumber || '';
        this.isTallWallProduct = this.dataset.isTallWallProduct === 'true';
        this.tallWallUrl = this.dataset.tallWallUrl || '/products/custom-tall-wall-curtains';

        this.addEventListener('input', this.handleInput.bind(this));
        this.addEventListener('change', this.handleChange.bind(this));
        this.boundHandleFormSubmit = this.handleFormSubmit.bind(this);
        if (this.productForm) this.productForm.addEventListener('submit', this.boundHandleFormSubmit, true);
        this.boundHandleQuantityChange = this.scheduleApiPPASync.bind(this);
        this.bindQuantityInput();
        this.apiPPASyncFrame = null;
        this.apiPPAObserver = new MutationObserver(() => this.scheduleApiPPASync());
        this.apiPPAObserver.observe(document.body, { childList: true, subtree: true });
        this.applyUrlSelections();
        if (!this.ensureCompatibleHeading()) return;
        this.updateProductPresentation();
        this.updatePreviewScale();
        this.updateSummary();
        this.updateLiveProductInfo();
        this.scheduleApiPPASync();
      }

      disconnectedCallback() {
        if (this.productForm && this.boundHandleFormSubmit) {
          this.productForm.removeEventListener('submit', this.boundHandleFormSubmit, true);
        }
        if (this.quantityInput && this.boundHandleQuantityChange) {
          this.quantityInput.removeEventListener('input', this.boundHandleQuantityChange);
          this.quantityInput.removeEventListener('change', this.boundHandleQuantityChange);
        }
        if (this.apiPPAObserver) this.apiPPAObserver.disconnect();
        if (this.apiPPASyncFrame) window.cancelAnimationFrame(this.apiPPASyncFrame);
      }

      handleInput() {
        this.clearMeasurementErrorIfComplete();
        this.updatePreviewScale();
        this.updateSummary();
        this.updateLiveProductInfo();
        this.scheduleApiPPASync();
      }

      scheduleApiPPASync() {
        if (this.apiPPASyncFrame) return;

        this.apiPPASyncFrame = window.requestAnimationFrame(() => {
          this.apiPPASyncFrame = null;
          this.syncApiPPACalculator();
        });
      }

      bindQuantityInput() {
        const formQuantityInput = this.productForm ? this.productForm.elements.namedItem('quantity') : null;
        const nextQuantityInput = formQuantityInput instanceof HTMLInputElement ? formQuantityInput : null;
        if (nextQuantityInput === this.quantityInput) return nextQuantityInput;

        if (this.quantityInput && this.boundHandleQuantityChange) {
          this.quantityInput.removeEventListener('input', this.boundHandleQuantityChange);
          this.quantityInput.removeEventListener('change', this.boundHandleQuantityChange);
        }

        this.quantityInput = nextQuantityInput;
        if (this.quantityInput && this.boundHandleQuantityChange) {
          this.quantityInput.addEventListener('input', this.boundHandleQuantityChange);
          this.quantityInput.addEventListener('change', this.boundHandleQuantityChange);
        }

        return this.quantityInput;
      }

      apiPPAInput(name) {
        return Array.from(document.querySelectorAll('#calculator .calc-prop.numInput-cpc')).find((input) => {
          const calculatorName = input.dataset.calcname || '';
          const propertyName = input.getAttribute('name') || '';
          return calculatorName.trim().toLowerCase() === name.toLowerCase() || propertyName === `properties[${name}]`;
        });
      }

      apiPPAQuantityInput(calculator) {
        let input = calculator.querySelector('[data-radiant-apippa-quantity]');
        if (input) return input;

        input = document.createElement('input');
        input.type = 'number';
        input.name = 'quantity';
        input.className = 'calc-prop';
        input.min = '1';
        input.value = '1';
        input.setAttribute('data-cpc_isquantity', 'true');
        input.setAttribute('data-radiant-apippa-quantity', '');
        calculator.appendChild(input);
        return input;
      }

      concealApiPPACalculator(calculator) {
        const target = calculator.closest('.cpc-calculator-target, #calculator-block') || calculator;
        target.classList.add('radiant-apippa-calculator--concealed');
        target.setAttribute('aria-hidden', 'true');

        calculator.querySelectorAll('input, select, textarea, button, a').forEach((control) => {
          control.setAttribute('tabindex', '-1');
        });
      }

      setApiPPAInputValue(input, value) {
        if (!input || input.value === value) return;

        const valueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
        if (valueSetter && valueSetter.set) valueSetter.set.call(input, value);
        else input.value = value;

        input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
        input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
      }

      syncApiPPACalculator() {
        const calculator = document.getElementById('calculator');
        if (!calculator) return false;

        const apiPPAWidth = this.apiPPAInput('Width');
        const apiPPADrop = this.apiPPAInput('Drop');
        const apiPPAQuantity = this.apiPPAQuantityInput(calculator);
        if (!apiPPAWidth || !apiPPADrop) return false;

        this.concealApiPPACalculator(calculator);
        const quantityInput = this.bindQuantityInput();
        const quantity = Math.max(1, Number.parseInt(quantityInput && quantityInput.value, 10) || 1);
        this.setApiPPAInputValue(apiPPAQuantity, String(quantity));
        if (!this.validMeasurement(this.widthInput) || !this.validMeasurement(this.dropInput)) return true;

        this.setApiPPAInputValue(apiPPAWidth, this.widthInput.value);
        this.setApiPPAInputValue(apiPPADrop, this.dropInput.value);
        return true;
      }

      validMeasurement(input) {
        const value = parseFloat(input && input.value);
        return Number.isFinite(value) && input.validity.valid;
      }

      calculatedPrice() {
        if (!window.RadiantCurtainPricing) return null;
        return window.RadiantCurtainPricing.calculate(this.widthInput && this.widthInput.value, this.dropInput && this.dropInput.value);
      }

      formattedPrice(price) {
        if (!Number.isFinite(price)) return '';

        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.currencyCode,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(price);
        } catch (_error) {
          return `$${price.toFixed(2)}`;
        }
      }

      productPriceElements() {
        const section = this.closest('[id^="MainProduct-"]');
        if (!section) return [];
        return section.querySelectorAll('.product__info-container [id^="price-"] .price-item--regular, .product__info-container [id^="price-"] .price-item--sale');
      }

      updateCalculatedPrice() {
        const price = this.calculatedPrice();
        const formatted = this.formattedPrice(price);

        if (this.pricePanel) this.pricePanel.hidden = !formatted;
        if (this.calculatedPriceOutput) this.calculatedPriceOutput.textContent = formatted;
        if (this.calculatedPriceInput) this.calculatedPriceInput.value = formatted;

        this.productPriceElements().forEach((element) => {
          if (!element.dataset.curtainOriginalPrice) element.dataset.curtainOriginalPrice = element.textContent;
          element.textContent = formatted || element.dataset.curtainOriginalPrice;
        });

        return formatted;
      }

      clearMeasurementErrorIfComplete() {
        [this.widthInput, this.dropInput].forEach((input) => {
          if (this.validMeasurement(input)) input.removeAttribute('aria-invalid');
        });
        if (!this.validMeasurement(this.widthInput) || !this.validMeasurement(this.dropInput)) return;
        if (this.measurementStep) this.measurementStep.classList.remove('is-invalid');
        if (this.measurementError) this.measurementError.hidden = true;
      }

      handleFormSubmit(event) {
        const firstInvalid = [this.widthInput, this.dropInput].find((input) => !this.validMeasurement(input));
        if (!firstInvalid) {
          this.clearMeasurementErrorIfComplete();
          this.syncApiPPACalculator();
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        [this.widthInput, this.dropInput].forEach((input) => {
          if (!this.validMeasurement(input)) input.setAttribute('aria-invalid', 'true');
        });
        if (this.measurementStep) {
          this.measurementStep.classList.add('is-invalid');
          this.measurementStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (this.measurementError) this.measurementError.hidden = false;
        window.setTimeout(() => firstInvalid.focus({ preventScroll: true }), 450);
      }

      handleChange() {
        if (!this.ensureCompatibleHeading()) return;
        this.updateProductPresentation();
        this.updatePreviewScale();
        this.updateSummary();
        this.updateLiveProductInfo();
        this.scheduleApiPPASync();
      }

      selectedColorInput() {
        return this.querySelector('[data-curtain-color]:checked');
      }

      applyUrlSelections() {
        const params = new URLSearchParams(window.location.search);
        const color = params.get('curtain_color') || params.get('color');
        const heading = params.get('heading') || params.get('curtain_heading');
        const exactHeadingStyle = params.get('heading_style');
        const lining = params.get('lining') || params.get('curtain_lining');

        if (color) {
          const escapedColor = window.CSS && CSS.escape ? CSS.escape(color) : color.replace(/"/g, '\\"');
          const colorInput = this.querySelector(`[data-curtain-color][data-color-key="${escapedColor}"]`);
          if (colorInput) colorInput.checked = true;
        }

        if (exactHeadingStyle) {
          const normalizedHeadingStyle = exactHeadingStyle.toLowerCase();
          const headingInput = Array.from(this.querySelectorAll('input[name="properties[Heading style]"]')).find(
            (input) => input.value.toLowerCase() === normalizedHeadingStyle
          );
          if (headingInput) headingInput.checked = true;
        } else if (heading) {
          const headingKey = heading.toLowerCase();
          let headingValue = '';
          if (headingKey.includes('valance')) headingValue = 'Valance';
          else if (headingKey.includes('tall')) headingValue = 'Tall windows';
          else if (headingKey.includes('pinch')) headingValue = 'Pinch pleat';
          else if (headingKey.includes('grommet')) headingValue = 'Grommet';
          const escapedHeading = headingValue && window.CSS && CSS.escape ? CSS.escape(headingValue) : headingValue.replace(/"/g, '\\"');
          const headingInput = escapedHeading ? this.querySelector(`input[name="properties[Heading style]"][value="${escapedHeading}"]`) : null;
          if (headingInput) headingInput.checked = true;
        }

        if (lining) {
          const liningKey = lining.toLowerCase();
          let liningValue = '';
          if (liningKey.includes('thermal')) liningValue = 'Thermal blackout lining';
          else if (liningKey.includes('blackout')) liningValue = 'Blackout lining';
          else if (liningKey.includes('privacy')) liningValue = 'Privacy lining';
          else if (liningKey.includes('unlined')) liningValue = 'Unlined';
          const escapedLining = liningValue && window.CSS && CSS.escape ? CSS.escape(liningValue) : liningValue.replace(/"/g, '\\"');
          const liningInput = escapedLining ? this.querySelector(`input[name="properties[Lining]"][value="${escapedLining}"]`) : null;
          if (liningInput) liningInput.checked = true;
        }
      }

      selectedColorLabel() {
        const selected = this.selectedColorInput();
        return selected ? selected.dataset.label || selected.value : 'White';
      }

      selectedColorKey() {
        const selected = this.selectedColorInput();
        return selected ? selected.dataset.colorKey || this.selectedColorLabel().toLowerCase() : 'white';
      }

      selectedProductTitle() {
        const headingLabels = {
          'grommet': 'Grommet',
          'pinch-pleat': 'Pinch Pleat',
          'valance': 'Valance',
          'tall-wall': 'Tall Windows'
        };
        const heading = headingLabels[this.selectedHeadingKey()] || this.selectedHeadingStyle();
        return `${this.selectedColorLabel()} Signature ${heading} Curtain`;
      }

      selectedHeadingStyle() {
        return this.selectedFieldValue('input[name="properties[Heading style]"]:checked', 'Grommet');
      }

      selectedHeadingKey() {
        const heading = this.selectedHeadingStyle().toLowerCase();
        if (heading.includes('valance')) return 'valance';
        if (heading.includes('tall')) return 'tall-wall';
        return heading.includes('pinch') ? 'pinch-pleat' : 'grommet';
      }

      selectedHeadingLabel() {
        const headingLabels = {
          'grommet': 'grommet',
          'pinch-pleat': 'pinch pleat',
          'valance': 'valance',
          'tall-wall': 'tall windows'
        };
        return headingLabels[this.selectedHeadingKey()] || this.selectedHeadingStyle().toLowerCase();
      }

      selectedDisplayTitle() {
        return this.selectedProductTitle();
      }

      standardCurtainPath() {
        const paths = {
          white: '/products/white-signature-grommet-curtain',
          ivory: '/products/ivory-signature-grommet-curtain',
          champagne: '/products/champagne-signature-grommet-curtain',
          'caramel-brown': '/products/white-signature-grommet-curtain',
          gray: '/products/gray-signature-grommet-curtain',
          charcoal: '/products/gray-signature-grommet-curtain',
          navy: '/products/navy-signature-grommet-curtain',
          blue: '/products/blue-signature-grommet-curtain',
          'sky-blue': '/products/blue-signature-grommet-curtain',
          green: '/products/green-signature-grommet-curtain',
          'olive-green': '/products/green-signature-grommet-curtain',
          yellow: '/products/yellow-signature-grommet-curtain',
          burgundy: '/products/burgundy-signature-grommet-curtain',
          'chocolate-brown': '/products/white-signature-grommet-curtain',
          orange: '/products/white-signature-grommet-curtain',
          'light-brown': '/products/white-signature-grommet-curtain'
        };
        return paths[this.selectedColorKey()] || paths.white;
      }

      ensureCompatibleHeading() {
        if (this.isTallWallProduct) {
          if (this.selectedHeadingKey() === 'tall-wall') return true;

          const destination = new URL(this.standardCurtainPath(), window.location.origin);
          destination.searchParams.set('curtain_color', this.selectedColorKey());
          destination.searchParams.set('heading', this.selectedHeadingKey());
          destination.searchParams.set('heading_style', this.selectedHeadingStyle());
          window.location.assign(destination.toString());
          return false;
        }

        if (this.selectedHeadingKey() !== 'tall-wall') return true;

        const destination = new URL(this.tallWallUrl, window.location.origin);
        destination.searchParams.set('curtain_color', this.selectedColorKey());
        destination.searchParams.set('heading', 'tall-windows');
        window.location.assign(destination.toString());
        return false;
      }

      freshAssetUrl(url) {
        if (!url) return '';
        return `${url.split('?')[0]}?v=20260721-2`;
      }

      colorAssetUrl(suffix = '') {
        const selected = this.selectedColorInput();
        if (!selected) return '';

        if (this.selectedHeadingKey() === 'valance') {
          const valanceGalleries = {
            burgundy: [
              'radiant-valance-burgundy-style.png',
              'radiant-valance-burgundy-style.png',
              'radiant-valance-burgundy-view-2.png'
            ],
            champagne: [
              'radiant-valance-champagne-style.png',
              'radiant-valance-champagne-room-2.png',
              'radiant-valance-champagne-view-2.png'
            ],
            gray: [
              'radiant-valance-gray-style.png',
              'radiant-valance-gray-room-2.png',
              'radiant-valance-gray-room.png'
            ],
            charcoal: [
              'radiant-valance-charcoal-style-v3.png',
              'radiant-valance-charcoal-style-v3.png',
              'radiant-valance-charcoal-style-v3.png'
            ],
            navy: [
              'radiant-valance-navy-blue-style.png',
              'radiant-valance-navy-blue-room-2.png',
              'radiant-valance-navy-blue-room.png'
            ],
            'navy-blue': [
              'radiant-valance-navy-blue-style.png',
              'radiant-valance-navy-blue-room-2.png',
              'radiant-valance-navy-blue-room.png'
            ],
            blue: [
              'radiant-valance-blue-style-v3.png',
              'radiant-valance-blue-style-v3.png',
              'radiant-valance-blue-style-v3.png'
            ],
            orange: [
              'radiant-valance-orange-style.png',
              'radiant-valance-orange-view-2.png',
              'radiant-valance-orange-flower-style.png'
            ],
            'light-brown': [
              'radiant-valance-light-brown-style.jpeg',
              'radiant-valance-golden-brown-room.png',
              'radiant-valance-fabric-champagne.png'
            ],
            'caramel-brown': [
              'radiant-valance-caramel-brown-style-v3.png',
              'radiant-valance-caramel-brown-style-v3.png',
              'radiant-valance-caramel-brown-style-v3.png'
            ],
            'chocolate-brown': [
              'radiant-valance-chocolate-brown-style-v3.png',
              'radiant-valance-chocolate-brown-style-v3.png',
              'radiant-valance-chocolate-brown-style-v3.png'
            ],
            yellow: [
              'radiant-valance-yellow-style-v3.png',
              'radiant-valance-yellow-style-v3.png',
              'radiant-valance-yellow-style-v3.png'
            ],
            ivory: [
              'radiant-valance-ivory-style-v3.png',
              'radiant-valance-ivory-style-v3.png',
              'radiant-valance-ivory-style-v3.png'
            ],
            white: [
              'radiant-valance-white-style-v3.png',
              'radiant-valance-white-style-v3.png',
              'radiant-valance-white-style-v3.png'
            ],
            green: [
              'radiant-valance-green-style-v3.png',
              'radiant-valance-green-style-v3.png',
              'radiant-valance-green-style-v3.png'
            ],
            'olive-green': [
              'radiant-valance-olive-green-style-v3.png',
              'radiant-valance-olive-green-room-v3.png',
              'radiant-valance-olive-green-view-v3.png'
            ],
            'sky-blue': [
              'radiant-valance-sky-blue-style-v3.png',
              'radiant-valance-sky-blue-room-v3.png',
              'radiant-valance-sky-blue-view-v3.png'
            ]
          };
          const gallery = valanceGalleries[this.selectedColorKey()] || valanceGalleries.champagne;
          const index = suffix === '-b' ? 1 : suffix === '-c' ? 2 : 0;
          const asset = gallery[index] || gallery[0];
          if (asset && selected.dataset.image) {
            const cleanSource = selected.dataset.image.split('?')[0];
            const assetRoot = cleanSource.slice(0, cleanSource.lastIndexOf('/') + 1);
            return this.freshAssetUrl(`${assetRoot}${asset}`);
          }
        }

        if (this.selectedHeadingKey() === 'tall-wall') {
          const colorKey = this.selectedColorKey();
          let variantSuffix = suffix;
          if (variantSuffix === '-c' && colorKey !== 'sky-blue' && colorKey !== 'white') variantSuffix = '-b';
          return selected.dataset.image ? this.freshAssetUrl(selected.dataset.image.replace(/radiant-curtain-[^/?]+-grommet\.png/, `radiant-curtain-tall-walls-${colorKey}${variantSuffix}.png`)) : '';
        }

        if (this.selectedHeadingKey() === 'pinch-pleat') {
          const pinchImage = selected.dataset.pinchPleatImage || selected.dataset.image;
          return pinchImage ? this.freshAssetUrl(pinchImage.replace('-pinch-pleat.png', `-pinch-pleat${suffix}.png`)) : '';
        }

        return selected.dataset.image ? this.freshAssetUrl(selected.dataset.image.replace('-grommet.png', `-grommet${suffix}.png`)) : '';
      }

      updateImage(image, src, alt) {
        if (!image || !src) return;

        image.src = src;
        image.removeAttribute('srcset');
        image.alt = alt;
      }

      updateProductPresentation() {
        const colour = this.selectedColorLabel();
        const colorKey = this.selectedColorKey();
        const productTitle = this.selectedDisplayTitle();
        const headingLabel = this.selectedHeadingLabel();
        const baseImage = this.colorAssetUrl();
        const detailImage = this.colorAssetUrl('-b');
        const stylingImage = this.colorAssetUrl('-c');

        document.querySelectorAll('.product__title h1, a.product__title h2').forEach((title) => {
          title.textContent = productTitle;
        });

        document.querySelectorAll('[data-curtain-product-media]').forEach((gallery) => {
          gallery.dataset.curtainProductMedia = colorKey;

          const images = gallery.querySelectorAll('img');
          this.updateImage(images[0], baseImage, `${colour} ${headingLabel} curtain in a living room`);
          this.updateImage(images[1], detailImage, `${colour} ${headingLabel} curtain fabric and heading detail`);
          this.updateImage(images[2], stylingImage, `${colour} ${headingLabel} curtain room styling`);

          const grid = gallery.querySelector('.radiant-curtain-product-media__grid');
          if (grid) grid.setAttribute('aria-label', `${colour} ${headingLabel} curtain gallery`);
        });

        document.querySelectorAll('.radiant-curtain-media-modal').forEach((modal) => {
          const images = modal.querySelectorAll('img');
          this.updateImage(images[0], baseImage, `${colour} ${headingLabel} curtain in a living room`);
          this.updateImage(images[1], detailImage, `${colour} ${headingLabel} curtain fabric and heading detail`);
          this.updateImage(images[2], stylingImage, `${colour} ${headingLabel} curtain room styling`);
        });
      }

      updatePreviewScale() {
        const width = parseFloat(this.widthInput && this.widthInput.value);
        const drop = parseFloat(this.dropInput && this.dropInput.value);
        const fullness = this.selectedFullness();
        const hasWidth = Number.isFinite(width);
        const hasDrop = Number.isFinite(drop);
        const widthScale = hasWidth ? Math.min(Math.max((width * fullness) / 160, 0.82), 1.18) : 1;
        const dropScale = hasDrop ? Math.min(Math.max(drop / 96, 0.82), 1.18) : 1;

        document.querySelectorAll('[data-curtain-product-media]').forEach((gallery) => {
          gallery.style.setProperty('--curtain-preview-scale-x', widthScale.toFixed(3));
          gallery.style.setProperty('--curtain-preview-scale-y', dropScale.toFixed(3));
        });
      }

      selectedPanelCount() {
        const selected = this.querySelector('input[name="properties[Panel format]"]:checked');
        return selected && selected.value === 'Single panel' ? 1 : 2;
      }

      selectedFullness() {
        const selectedFullness = this.querySelector('[data-curtain-fullness]:checked');
        const value = selectedFullness ? selectedFullness.value : `${this.dataset.defaultFullness || 2}x`;
        const parsed = parseFloat(value);
        return Number.isFinite(parsed) ? parsed : 2;
      }

      selectedFieldValue(selector, fallback = '') {
        const field = this.querySelector(selector);
        return field && field.value ? field.value : fallback;
      }

      selectedFieldLabel(selector, fallback = '') {
        const field = this.querySelector(selector);
        if (!field) return fallback;

        const label = field.closest('label');
        const text = label ? label.querySelector('span') : null;
        return text && text.textContent.trim() ? text.textContent.trim() : field.value || fallback;
      }

      measurementDetails() {
        const width = parseFloat(this.widthInput && this.widthInput.value);
        const drop = parseFloat(this.dropInput && this.dropInput.value);
        const hasWidth = Number.isFinite(width);
        const hasDrop = Number.isFinite(drop);
        const fullness = this.selectedFullness();
        const panels = this.selectedPanelCount();
        const panelLabel = panels === 1 ? 'panel' : 'panels';

        if (!hasWidth || !hasDrop) {
          return {
            hasMeasurements: false,
            sizeLabel: 'Size: add measurements',
            description: 'Enter the width and height to complete the made-to-measure sizing.',
            measurementSummary: ''
          };
        }

        const totalFabricWidth = Math.round(width * fullness * 10) / 10;
        const perPanelWidth = Math.round((totalFabricWidth / panels) * 10) / 10;
        const measurementSummary = `${totalFabricWidth}${this.unit} total fabric width, ${perPanelWidth}${this.unit} per ${panelLabel}, ${drop}${this.unit} height`;

        return {
          hasMeasurements: true,
          sizeLabel: `Size: ${width}${this.unit} x ${drop}${this.unit}`,
          description: `Made for a ${width}${this.unit} width and a ${drop}${this.unit} height, using ${measurementSummary}.`,
          measurementSummary
        };
      }

      liveProductState() {
        const colour = this.selectedColorLabel();
        const panelFormat = this.selectedFieldValue('input[name="properties[Panel format]"]:checked', 'Pair of panels');
        const heading = this.selectedHeadingStyle();
        const fabric = this.selectedFieldValue('input[name="properties[Fabric]"]:checked', 'White linen weave');
        const lining = this.selectedFieldValue('input[name="properties[Lining]"]:checked', 'Unlined');
        const mount = this.selectedFieldValue('select[name="properties[Mounting preference]"]', 'Outside frame');
        const fullnessLabel = this.selectedFieldLabel('[data-curtain-fullness]:checked', `${this.selectedFullness()}x`);
        const measurements = this.measurementDetails();
        const description = `${colour} curtain in ${fabric.toLowerCase()} configured as ${panelFormat.toLowerCase()} with ${heading.toLowerCase()} heading, ${lining.toLowerCase()}, ${fullnessLabel.toLowerCase()} fullness, and ${mount.toLowerCase()} mounting. ${measurements.description} Radiant Interiors will confirm allowances before production.`;

        return {
          labels: [
            { label: `Colour: ${colour}`, target: 'color' },
            { label: measurements.sizeLabel, target: 'size' },
            { label: `Style: ${heading}`, target: 'heading' },
            { label: `Fabric: ${fabric}`, target: 'fabric' },
            { label: `Lining: ${lining}`, target: 'lining' },
            { label: `Fullness: ${fullnessLabel}`, target: 'fullness' },
            { label: `Panels: ${panelFormat}`, target: 'panels' }
          ],
          description
        };
      }

      focusCustomizerTarget(target) {
        const selectors = {
          color: '[data-curtain-color]:checked',
          size: '[data-curtain-width]',
          heading: 'input[name="properties[Heading style]"]:checked',
          fabric: 'input[name="properties[Fabric]"]:checked',
          lining: 'input[name="properties[Lining]"]:checked',
          fullness: '[data-curtain-fullness]:checked',
          panels: 'input[name="properties[Panel format]"]:checked'
        };
        const selector = selectors[target];
        const field = selector ? this.querySelector(selector) : null;
        if (!field) return;

        const area = field.closest('fieldset, .curtain-customizer__step, label') || field;
        area.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => field.focus({ preventScroll: true }), 250);
      }

      replaceChildrenWithTextSpans(container, labels) {
        if (!container) return;

        container.innerHTML = '';
        labels.forEach(({ label, target }) => {
          const item = document.createElement('button');
          item.type = 'button';
          item.textContent = label;
          item.addEventListener('click', () => this.focusCustomizerTarget(target));
          container.appendChild(item);
        });
      }

      updateLiveProductInfo() {
        const state = this.liveProductState();

        this.livePanels.forEach((panel) => {
          panel.hidden = false;
        });

        this.liveLabelGroups.forEach((group) => {
          this.replaceChildrenWithTextSpans(group, state.labels);
        });

        this.liveDescriptions.forEach((description) => {
          description.textContent = state.description;
        });

        this.productDescriptions.forEach((description) => {
          description.textContent = state.description;
        });
      }

      buildBrief(measurementSummary) {
        const colour = this.selectedColorLabel();
        const panelFormat = this.selectedFieldValue('input[name="properties[Panel format]"]:checked', 'Pair of panels');
        const heading = this.selectedHeadingStyle();
        const fabric = this.selectedFieldValue('input[name="properties[Fabric]"]:checked', 'White linen weave');
        const lining = this.selectedFieldValue('input[name="properties[Lining]"]:checked', 'Unlined');
        const mount = this.selectedFieldValue('select[name="properties[Mounting preference]"]', 'Outside frame');
        const email = this.emailInput && this.emailInput.value ? this.emailInput.value : '';
        const phone = this.phoneInput && this.phoneInput.value ? this.phoneInput.value : '';
        const parts = [
          `Colour: ${colour}`,
          measurementSummary,
          `Panels: ${panelFormat}`,
          `Heading: ${heading}`,
          `Fabric: ${fabric}`,
          `Lining: ${lining}`,
          `Mount: ${mount}`
        ];

        if (email) parts.push(`Email: ${email}`);
        if (phone) parts.push(`WhatsApp: ${phone}`);

        return parts.filter(Boolean).join(' | ');
      }

      updateWhatsappLink(brief) {
        if (!this.whatsappLink || !this.whatsappNumber) return;

        const message = `Radiant Interiors curtain brief: ${brief}`;
        this.whatsappLink.href = `https://wa.me/${this.whatsappNumber}?text=${encodeURIComponent(message)}`;
      }

      updateSummary() {
        const colour = this.selectedColorLabel();
        const width = parseFloat(this.widthInput && this.widthInput.value);
        const drop = parseFloat(this.dropInput && this.dropInput.value);
        const formattedPrice = this.updateCalculatedPrice();

        if (!Number.isFinite(width) || !Number.isFinite(drop) || !formattedPrice) {
          const brief = `Colour: ${colour}`;
          this.summary.textContent = `${colour} selected. Enter a valid width and drop to calculate the curtain price.`;
          this.helper.textContent = 'Valid widths are 40–200 in and heights are 84–240 in, using 0.5-in increments.';
          this.summaryInput.value = brief;
          this.whatsappSummaryInput.value = brief;
          this.updateWhatsappLink(brief);
          return;
        }

        const fullness = this.selectedFullness();
        const panels = this.selectedPanelCount();
        const totalFabricWidth = Math.round(width * fullness * 10) / 10;
        const perPanelWidth = Math.round((totalFabricWidth / panels) * 10) / 10;
        const panelLabel = panels === 1 ? 'panel' : 'panels';
        const measurementSummary = `${totalFabricWidth}${this.unit} total fabric width, ${perPanelWidth}${this.unit} per ${panelLabel}, ${drop}${this.unit} height`;
        const brief = `${this.buildBrief(measurementSummary)} | Calculated price: ${formattedPrice}`;

        this.summary.textContent = `${colour}: ${measurementSummary}`;
        this.helper.textContent = `${formattedPrice} for the selected size. ${fullness}x fullness across ${panels} ${panelLabel}.`;
        this.summaryInput.value = brief;
        this.whatsappSummaryInput.value = brief;
        this.updateWhatsappLink(brief);
      }
    }
  );
}
